import type { ReactNode } from "react";
import { Controller } from "react-hook-form";
import { Input } from "@onengine/component-library";
import type { ControlledFieldProps } from "./types";

export function ControlledInput({
  name,
  control,
  error,
  clearErrors,
  placeholder,
  size = "small",
  iconLeft,
  onlyNumeric,
}: ControlledFieldProps & {
  placeholder?: string;
  size?: "small" | "large";
  iconLeft?: ReactNode;
  onlyNumeric?: boolean;
}) {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field }) => (
        <Input
          value={field.value || ""}
          onChange={(val) => {
            const next = onlyNumeric ? String(val).replace(/[^0-9.-]/g, "") : val;
            field.onChange(next);
            clearErrors(name);
          }}
          placeholder={placeholder || "Enter..."}
          size={size}
          error={error}
          iconLeft={iconLeft}
        />
      )}
    />
  );
}
